import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';

export default function Signin() {
    return (
        <>
            <Header />
            <section className='sign_in py-5 h_70vh'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 m-auto">
                            <h1 className="fs-4 text-center border-bottom pb-3">Sign in</h1>
                            <form action="" className="mt-4">
                                <div className="d-flex align-items-center justify-content-between gap-3">
                                    <div className="d-flex flex-column">
                                        <label htmlFor="Cfname" className='fs_13 fw_600'>First Name <sup className="text-danger">*</sup> </label>
                                        <input type="text" id='Cfname' />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <label htmlFor="Clname" className='fs_13 fw_600'>Last Name <sup className="text-danger">*</sup> </label>
                                        <input type="text" id='Clname' />
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between gap-3">
                                    <div className="d-flex flex-column">
                                        <label htmlFor="phone" className='fs_13 fw_600'>Phone No <sup className="text-danger">*</sup> </label>
                                        <input type="text" id='phone' />
                                    </div>
                                    <div className="d-flex flex-column">
                                        <label htmlFor="ppassword" className='fs_13 fw_600'>Password <sup className="text-danger">*</sup> </label>
                                        <input type="text" id='ppassword' />
                                    </div>
                                </div>
                                <a href="/login" className="fs_12 text-center d-block">Already have account Login</a>
                                <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                                    <button className='default_btn' type='button'>Create an Account</button>
                                    <button className='primary_btn' type='reset'>Reset Fill Content</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
